import update from 'immutability-helper';
import * as types from './types';

export const initialState = {
  isFetching: true,
  errorCode: 0,
  errorMsg: '',
  payload: null,
  response: null,
  updateDate: null,
};

export default type => (state = [], action) => {
  const switchMap = {};

  switchMap[`${type}${types.INIT}`] = () => update(state, {
    $splice: [[action.index, 1, { ...initialState }]],
  });

  switchMap[`${type}${types.INIT_ALL_REQUESTS}`] = () => update(state, {
    $set: Array.from({ length: action.count }, () => ({
      ...initialState,
    })),
  });

  switchMap[`${type}${types.SET_PAYLOAD}`] = () => update(state, {
    [action.index]: {
      payload: {
        $set: action.payload,
      },
    },
  });

  switchMap[`${type}${types.SWITCH_REQUEST}`] = () => {
    const requests = state;
    const { index, target } = action;
    const tempRequest = requests[index];
    requests[index] = requests[target];
    requests[target] = tempRequest;
    return update(state, {
      $set: requests,
    });
  };

  switchMap[`${type}${types.SET_RESPONSE}`] = () => update(state, {
    [action.index]: {
      response: {
        $set: action.response,
      },
    },
  });

  switchMap[`${type}${types.FETCHING}`] = () => update(state, {
    [action.index]: {
      $merge: {
        isFetching: true,
        errorCode: 0,
        errorMsg: '',
      },
    },
  });

  switchMap[`${type}${types.FETCHING_SUCCESS}`] = () => update(state, {
    [action.index]: {
      $merge: {
        isFetching: false,
        errorCode: 0,
        errorMsg: '',
        updateDate: Date.now(),
      },
    },
  });

  switchMap[`${type}${types.FETCHING_FAIL}`] = () => update(state, {
    [action.index]: {
      $merge: {
        isFetching: false,
        errorCode: action.errorCode,
        errorMsg: action.errorMsg,
        updateDate: Date.now(),
      },
    },
  });

  return switchMap[action.type]
    ? switchMap[action.type]()
    : state;
};
